import { render, staticRenderFns } from "./EditorFields.vue?vue&type=template&id=fed2843e&"
import script from "./EditorFields.vue?vue&type=script&lang=ts&"
export * from "./EditorFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports